<template>
  <div
    ref="cont"
    class="solfigr_steps text-noselect"
    tabindex="1"
    data-tst="solfigr_steps"
  >
    <div class="solfigr_steps_content">
      <TabBox
        class="flex-1"
        :options="stepOptions"
        :tab="step"
        idKey="id"
        style="
          --clr-tbbox-tab-back: transparent;
          --tbbox-content-clr-back: var(--clr-black-1-3);
          --tbbox-content-padding: 0.75rem 0.75rem 0.75rem 0.75rem;
          --tbbox-overflow-y: none;
          --tbbox-overflow-x: none;
          --z-index-tbbox-content: 4;
        "
        tabsStyle="
           --height: 2.75rem;
           --height-inner: 3rem;
           --tab-fnt-size: 1rem;
           --tab-radius: 8px;
           --inner-flex: 1;
           --tab-flex: 1;
           --padding-inner: 0 0 0 0;
           --clr-tbbox-tab-back: transparent;
           --tab-justify-content: center;
           --clr-tab-back:var(--clr-black-1)
          "
        @click="
          item => {
            step = item
          }
        "
      >
        <template #tab="{ item }">
          <div class="f-center">
            <div
              style="transition: 0.15s; margin: 0 0.5rem 0 0"
              :style="
                item === 'setup' && !canConfirm
                  ? `color: var(--clr-error);`
                  : item === step
                    ? `color: var(--clr-white-0);`
                    : `color: var(--clr-grey-2);;`
              "
              class="text-normal-large mdi"
              :class="item === 'setup' ? 'mdi-cog' : 'mdi-information-outline'"
            ></div>
            {{ $t(`solfigr.titles.${item}`) }}
          </div>
        </template>
        <div
          class="f-column flex-1"
          style="gap: 1rem; min-width: 0; min-height: 0"
        >
          <div
            class="f-column flex-1"
            style="gap: 0.5rem; min-height: 0"
          >
            <div
              class="d-flex f-column flex-1 position-relative"
              style="
                min-height: 0;
                height: 100%;
                --solfigr-gap: 0.75rem;
                --solfigr-padding: 0.75rem;
                --solfigr-gap: 1rem;
                --solfigr-padding: 1rem;
              "
            >
              <div
                class="d-flex f-column flex-1 medium-scroll-track"
                style="
                  min-height: 0;
                  height: 100%;
                  overflow-y: auto;
                  overflow-x: hidden;
                  border-radius: 4px;
                  gap: 0.5rem;
                  gap: var(--solfigr-gap);
                "
              >
                <SolfigrSolution
                  v-if="step === 'setup'"
                  ref="step1"
                  :namespace
                  :startStreet
                  :gameformat
                  :shortcut
                  :stack
                  :players
                  :stacks
                  :pot
                  :blind
                  :ante
                  :anteDistributionMethod
                  :allowLimp
                  :allowRake
                  :rakePercent
                  :rakeCap
                  :preflopRakeType
                  :tournamentType
                  :icmTournament
                  :icmPlayersAndStacks
                  :icmHandDetails
                  :inputTabIndex="1"
                  :shortcutsLoading="shortcutsLoading || treesLoadingGET"
                  :presetLoading="presetLoading || treesLoadingGET"
                  :shouldShowAddPlayerButton
                  :showComingSoonPlayerIcm
                  @update:stacksValid="val => (localStacksValid = val)"
                  @update:input="
                    ({ num, type }) =>
                      handleUpdate({
                        value: num,
                        key: `slfrm_${type}`,
                        resetTreeOperationsAll: true,
                        fromStart: true,
                      })
                  "
                  @update:startstreet="
                    value =>
                      handleUpdate({
                        value,
                        key: `slfrm_startStreet`,
                        resetTreeOperationsAll: true,
                        fromStart: true,
                      })
                  "
                  @update:icmTournament="
                    value =>
                      handleIcmUpdate({
                        value,
                        key: `slfrm_icm_tournament`,
                      })
                  "
                  @update:icmHandDetails="
                    value =>
                      handleIcmUpdate({
                        value,
                        key: `slfrm_icm_handDetails`,
                      })
                  "
                  @update:icmPlayersAndStacks="
                    value =>
                      handleIcmUpdate({
                        value,
                        key: `slfrm_icm_playersAndStacks`,
                      })
                  "
                >
                </SolfigrSolution>
                <SolfigrBetSizes
                  v-if="step === 'setup'"
                  :loading="shortcutsLoading || treesLoadingGET || presetLoading"
                  :namespace
                  :isPreflop
                  :sizes
                  :players
                  :useFlopSizesOnAllStreets
                  :playersCloningFirstPlayer
                  :allinTreshold
                  :allinIfLessThan
                  :mergeSizesThresholdPreflop
                  :mergeSizesThresholdFlop
                  :formResult
                  :maxNumRaises
                  @update:sizes="
                    ({ sizes, street }) =>
                      handleUpdate({
                        value: sizes,
                        key: 'slfrm_sizes',
                        street,
                        resetTreeOperationsTillStreet: true,
                        resetTreeOperationsAll: startStreet === street,
                        fromStart: startStreet === street,
                      })
                  "
                  @update:allinsettings="
                    ({ value, key }) =>
                      handleUpdate({
                        value,
                        key,
                        resetTreeOperationsAll: true,
                        fromStart: true,
                      })
                  "
                  @update:cloneToFirstPlayer="
                    value => setState({ value, key: 'slfrm_playersCloningFirstPlayer' })
                  "
                  @update:useFlopSizesOnAllStreets="
                    value =>
                      setState({
                        value,
                        key: 'slfrm_useFlopSizesOnAllStreets',
                      })
                  "
                  @update:preview="handleUpdateTreePreview"
                >
                </SolfigrBetSizes>

                <!-- Summary tab -->
                <SolfigrSummary
                  v-if="step === 'summary'"
                  :loading="treesLoadingGET"
                  :namespace
                  :formResult
                >
                </SolfigrSummary>
              </div>
            </div>

            <ExpandCard
              :opened="false"
              persistKey="solfigr_preview"
              style="
                --clr-back-title: var(--clr-black-2);
                --clr-back-title-hover: var(--clr-black-2-3);
                --clr-back-title-active: var(--clr-black-2);
                --title-color: var(--clr-white-0);
                --content-padding: 0.5rem;
                --max-height: 14rem;
                --radius: 4px;
                --radius-title: 4px 4px 0 0;
                --radius-content: 0 0 4px 4px;
                --open-overflow: unset;
                --overflow-content-open-y: unset;
                --overflow-content-open-x: unset;
              "
              data-tst="solfigr_tree"
            >
              <template #title>
                <div
                  class="f-center gw_hvr"
                  style="min-width: 0"
                >
                  <div>
                    {{ $t(`solfigr.tree_edit`) }}
                  </div>
                  <div
                    v-if="modeAutoDynaIncluded"
                    class="ml-4 clr-grey text-medium f-center"
                    style="min-width: 0"
                    @click.stop
                  >
                    <GwTooltip
                      class="f-center"
                      style="--hvr-content-opacity: 0.5"
                      :tooltip="$t('solfigr.auto_dyn_sizes_reduce_tooltip')"
                    >
                      <template #opener>
                        <div class="mdi mdi-information-outline mr-1"></div>
                        {{ $t('solfigr.auto_dyn_sizes_reduce') }}
                      </template>
                    </GwTooltip>
                  </div>
                </div>
              </template>
              <PokerHistoryEvents
                :namespace="namespace"
                :canAISolve="false"
                :useTreePreview="true"
                :skeletonTiles="2"
                :actionEmitOnly="true"
                :hasNodeEdit="true"
                :hasMinimized="false"
                :hasInitialLoad="false"
                :hasGameformat="false"
                :hasShortcuts="false"
                :hasWatcherEnabled="false"
                :hasEmptyBoard="true"
                :clickableBoard="false"
                :hasTurnPreload="false"
                :openToTop="true"
                :hasGGSaveSpot="false"
                :customLoading="hSpotsLoading"
                :routerParams="{
                  push: false,
                  replace: false,
                  saveLocally: false,
                }"
                style="
                  --clr-hero: var(--clr-hero-default);
                  --clr-hs-back: var(--clr-black-2);
                  --hs-spot-clr-border: var(--clr-black-2);
                "
                @click:action="handleUpdateTreePreview"
                @click:nodeedit="openNodeEditDialog"
              />
            </ExpandCard>
          </div>
          <template v-if="solRepNamespace === 'rep'">
            <div
              class="gw_text gw_text-sm d-flex items-center"
              style="gap: 0.25rem"
              :style="lastReportPrice < creditsBalance ? '' : { color: '#ffb74d' }"
            >
              <template v-if="lastReportPrice < creditsBalance">
                <div
                  class="mdi mdi-help-circle-outline"
                  :style="{ color: 'var(--palette-primary-main)' }"
                />
                {{ $t('solfigr.dynamic_price.info') }}
                <a
                  href="https://blog.gtowizard.com/introducing_custom_aggregated_reports/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ $t('solfigr.dynamic_price.read') }}
                </a>
              </template>
              <template v-else>
                <exclamationTriangle style="width: 20px; height: 20px" />
                {{ $t('solfigr.dynamic_price.alert') }}
              </template>
            </div>
          </template>
          <div class="solfigr_steps_bottom mt-auto">
            <div
              class="d-flex"
              style="gap: 0.25rem"
            >
              <button
                class="gw_btn gw_btn-v1"
                data-tst="solfigr_load_btn"
                type="button"
                @click="openSavedTreesDialog()"
              >
                <div class="mdi mdi-folder text-semi-large mr-1"></div>
                {{ $t('btn.load') }}
              </button>

              <button
                class="gw_btn gw_btn-v1"
                type="button"
                :class="{ 'gw_btn_disabled no-events': !canConfirm }"
                style="--clr-disabled: var(--clr-grey-2)"
                data-tst="solfigr_save_btn"
                @click="openSaveTreeDialog()"
              >
                <i class="mdi mdi-content-save text-semi-large mr-1"></i>
                {{ $t('btn.save') }}
              </button>
            </div>

            <div class="ml-auto d-flex">
              <button
                v-if="!mobile"
                class="gw_btn gw_btn_text gw_btn-v1 mr-2"
                type="button"
                @click="$emit('close')"
              >
                {{ $t('btn.close') }}
              </button>

              <router-link
                v-if="solRepNamespace === 'rep' && creditsBalance < lastReportPrice"
                :to="{ name: 'UserCredits' }"
              >
                <button
                  class="gw_btn-v1 gw_btn_primary ml-auto mr-2"
                  type="button"
                >
                  {{ $t('solfigr.dynamic_price.buy') }}
                  <template v-if="!mobile">PowerCredits</template>
                  <Chip
                    v-if="mobile"
                    class="chip"
                  />
                </button>
              </router-link>
              <button
                class="gw_btn-v1 ml-auto"
                :class="{
                  'csst ml-auto':
                    !canConfirm ||
                    !localStacksValid ||
                    (solRepNamespace === 'rep' && creditsBalance < lastReportPrice),
                  gw_btn_primary:
                    canConfirm &&
                    localStacksValid &&
                    (solRepNamespace !== 'rep' || creditsBalance >= lastReportPrice),
                }"
                :data-tst="`btn_create_custom_solution${
                  canConfirm &&
                  localStacksValid &&
                  (solRepNamespace !== 'rep' || creditsBalance >= lastReportPrice)
                    ? ''
                    : '_disabled'
                }`"
                type="button"
                :disabled="
                  !canConfirm ||
                  !localStacksValid ||
                  (solRepNamespace === 'rep' && creditsBalance < lastReportPrice) ||
                  reportPriceHook?.isPending?.value
                "
                @click="confirm()"
              >
                <LoaderSpinner
                  v-show="reportPriceHook?.isPending?.value"
                  style="--size: 1.5rem; position: absolute"
                />
                <span
                  class="btn_create_custom_solution_text"
                  :class="{
                    opacity_0: treesLoadingPOST || !reportPriceHook?.isPending,
                    'gw_btn-v1 gw_btn_disabled no-events':
                      !canConfirm ||
                      !localStacksValid ||
                      (solRepNamespace === 'rep' && creditsBalance < lastReportPrice),
                  }"
                  data-tst="create_custom_solution"
                  :style="{
                    '--clr-disabled':
                      !canConfirm ||
                      !localStacksValid ||
                      (solRepNamespace === 'rep' && creditsBalance < lastReportPrice)
                        ? 'var(--clr-grey-2)'
                        : '',
                  }"
                >
                  <template v-if="solRepNamespace === 'rep' && lastReportPrice">
                    <Chip class="chip" />
                    {{ lastReportPrice }} |
                  </template>
                  {{ createButtonText }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </TabBox>
    </div>
  </div>
</template>

<script>
import { throttle } from 'lodash'
import { getSolfigrFields } from '@/store/solfigr/solfigr_helpers'
import {
  getHistoryUrlParams,
  setHsSelectedAction,
  setHsPresetSelectedActions,
} from '@/store/gamestate/gamestate'
import { SNK } from '@/helpers/helpers'
import { getRouteNameByStudyTab } from '@/store/router/router'
import { namespaces, PowerCredits } from '@/helpers/constants'
import { useGetReportPrice } from '@gto/api/vue-query'

import PokerHistoryEvents from '@/components/Poker/PokerHistoryEvents/PokerHistoryEvents'
import SolfigrSolution from '@/components/ConfigureSolution/SolfigrSolution'
import SolfigrBetSizes from '@/components/ConfigureSolution/SolfigrBetSizes'
import SolfigrSummary from '@/components/ConfigureSolution/SolfigrSummary'
import GwBtn from '@/components/lib/GwBtn/GwBtn.vue'

import float_mix from '@/mixins/float_mix'
import TabBox from '@/components/lib/TabBox'
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import GwTooltip from '@/components/lib/GwTooltip'
import format_mix from '@/mixins/format_mix'
import Chip from '@/assets/icons/chip.svg'
import exclamationTriangle from '@/assets/icons/exclamation-triangle.svg'

export default {
  name: 'SolfigrSteps',
  components: {
    SolfigrSolution,
    SolfigrBetSizes,
    SolfigrSummary,
    PokerHistoryEvents,
    TabBox,
    LoaderSpinner,
    ExpandCard,
    GwTooltip,
    Chip,
    exclamationTriangle,
    GwBtn,
    PowerCredits,
  },
  mixins: [float_mix, format_mix],
  props: {
    namespace: { String, required: true },
    instaPrefill: Boolean,
    solfigrNewTreeMode: { default: 'createnew' },
    labelId: String,
  },
  emits: ['close'],
  data() {
    this.conf = getSolfigrFields()
    this.stepOptions = ['setup', 'summary']
    this.reportPriceHook = null
    this.lastReportPrice = 0
    return {
      step: 'setup',
      l_formResultStr: '',
      nodeEditedSpot: null,
      localStacksValid: true,
    }
  },
  created() {
    this.emptyForm()
    this.emptyHspots()
    this.initializeRouter()
    this.prefillForm()
    this.getTreePreview()
  },
  mounted() {
    this.calculateReportPrice()
  },
  methods: {
    getImage(id) {
      return new URL(`/src/assets/img/${id}`, import.meta.url).href
    },
    emptyForm() {
      this.$store.commit(`${this.namespace}/slfrm_reset`, {
        slfrm_startStreet: 'preflop',
      })

      const street = this.solElite.starting_street

      if (street) {
        this.$store.commit(`${this.namespace}/slfrm_set`, {
          key: 'slfrm_startStreet',
          value: this.instaPrefill ? 'flop' : street.toLowerCase(),
        })
      }
    },
    initializeRouter() {
      this.$store.dispatch(`${this.namespace}/router_initialize`)

      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.namespace,
        to_namespace: this.namespace,
        queryGroup: 'router-to-gmf-selektor',
      })

      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.namespace,
        to_namespace: this.namespace,
        queryGroup: 'router',
      })
    },
    fetchCustomSolution() {
      this.$store.dispatch('api_poker_custom_solution_tree', {
        id: this.solElite.custom_tree_id,
        action: `${this.namespace}/slfrm_applyApiCustomTree`,
        actionArgs: {
          solfigrPresetMode: 'restoreall',
        },
      })
    },
    fetchShortcut() {
      this.$store.dispatch('api_poker_shortcuts', {
        namespace: this.namespace,
        action: `${this.namespace}/slfrm_applyApiShortcuts`,
        actionArgs: { solfigrPresetMode: 'createnew' },
      })
    },
    prefillForm() {
      const canFetchCustomTree = this.solElite.custom_tree_id

      if (this.instaPrefill) {
        this.$store.dispatch('api_poker_player_ranges_spot', {
          namespace: this.namespace,
          labelId: this.labelId,
        })
        return
      }

      if (canFetchCustomTree) {
        this.fetchCustomSolution()
        return
      }
      this.fetchShortcut()
      this.calculateReportPrice()
    },
    handleUpdateTreeOperations() {
      const hSpot = this.nodeEditedSpot
      let hSpots = this.$store.getters[`${this.namespace}/history_spots`]
      hSpots = hSpots.filter(e => e.id < hSpot.id)
      const hSpotsParams = getHistoryUrlParams({ history_spots: hSpots, includeShowdown: false })

      this.$store.commit(`${this.namespace}/gamestate_set`, {
        key: 'history_spots',
        value: hSpots,
      })

      this.getTreePreview({
        hSpotsParams,
        force: true,
        treeOperationsUpdate: true,
        fromStart: false,
      })
    },
    handleUpdateTreePreview({ item, action }) {
      let hSpots = this.$store.getters[`${this.namespace}/history_spots`]
      hSpots = hSpots.filter(e => e.id <= item.id)
      if (item.preset_action_code) {
        hSpots = setHsPresetSelectedActions({ history_spots: hSpots, spot: item })
      }
      hSpots = setHsSelectedAction({ history_spots: hSpots, spot: item, action, getNext: true })

      this.$store.commit(`${this.namespace}/gamestate_set`, {
        key: 'history_spots',
        value: hSpots,
      })

      const hSpotsParams = getHistoryUrlParams({ history_spots: hSpots, includeShowdown: false })
      this.getTreePreview({
        hSpotsParams, //
        force: true,
        fromStart: false,
      })
    },
    setState({ key, value }) {
      this.$store.commit(`${this.namespace}/slfrm_set`, { key, value })
    },
    handleIcmUpdate({ key, value }) {
      this.$store.dispatch(`${this.namespace}/slrfm_updateIcmInheritedValues`, {
        icmTournament: key === 'slfrm_icm_tournament' ? value : this.icmTournament,
        icmHandDetails: key === 'slfrm_icm_handDetails' ? value : this.icmHandDetails,
        icmPlayersAndStacks:
          key === 'slfrm_icm_playersAndStacks' ? value : this.icmPlayersAndStacks,
        getTreePreview: false,
      })
      this.handleUpdate({
        value,
        key,
        resetTreeOperationsAll: true,
        fromStart: true,
        setState: false,
      })
    },
    handleUpdate({
      value, //
      key,
      street,
      fromStart = false,
      resetTreeOperationsAll = false,
      resetTreeOperationsTillStreet = false,
      setState = true,
    }) {
      if (setState) {
        this.setState({ key, value })
      }

      street = street !== 'preflop' && this.useFlopSizesOnAllStreets ? 'flop' : street
      this.getTreePreview({
        fromStart,
        street,
        resetTreeOperationsAll,
        resetTreeOperationsTillStreet,
      })
    },
    getTreePreview({
      hSpotsParams,
      force = false,
      treeOperationsUpdate = false,
      fromStart = true,
      street = '',
      resetTreeOperationsAll = false,
      resetTreeOperationsTillStreet = false,
    } = {}) {
      // reset tree preview on change of each street settings
      // --when startStreet (preflop/flop) changes reset all, when turn changes reset river
      // treeOperations should be reseted the same
      // when settings don't change dont call preview (except when force)

      if (!force) {
        const fmr = JSON.parse(JSON.stringify(this.formResult))
        fmr.players[0].display_position = 'ignore-when-updating-range'
        fmr.players[1].display_position = 'ignore-when-updating-range'
        const strParams = JSON.stringify(fmr)
        if (strParams === this.l_formResultStr) {
          return
        }
        this.l_formResultStr = strParams
      }

      if (fromStart) {
        this.$store.commit(`${this.namespace}/gamestate_set`, {
          key: 'history_spots',
          value: [],
        })
      } else if (street) {
        // keep spots on prev streets
        let hSpots = this.$store.getters[`${this.namespace}/history_spots`]
        if (!hSpots.some(i => i.street === street)) {
          return
        } // no point of calling preview if user didi not visited this street

        const firstStreetSpot = hSpots.find(e => e.street === street)
        const spotId = firstStreetSpot?.id || 0
        hSpots = hSpots.filter(e => e.id < spotId)
        this.$store.commit(`${this.namespace}/gamestate_set`, {
          key: 'history_spots',
          value: hSpots,
        })
        hSpotsParams = getHistoryUrlParams({
          history_spots: hSpots,
          includeShowdown: false,
        })
      }

      let treeOperations = this.$store.getters[`${this.namespace}/slfrm_treeOperations`]
      if (resetTreeOperationsAll) {
        treeOperations = []
        this.$store.commit(`${this.namespace}/slfrm_set`, {
          key: 'slfrm_treeOperations',
          value: treeOperations,
        })
      } else if (resetTreeOperationsTillStreet) {
        // keep oprerations only on prev streets
        // reset all nodeedits on current street and next streets
        // exmpl: (if street is turn -- keep only preflop and flop)
        const n = { preflop: 1, flop: 2, turn: 3, river: 4 }[street] || 4
        treeOperations = treeOperations.filter(i => i.action_history.length < n)

        this.$store.commit(`${this.namespace}/slfrm_set`, {
          key: 'slfrm_treeOperations',
          value: treeOperations,
        })
      }

      this.$store.commit('api_update', {
        key: 'api_poker_tree_preview',
        result: {
          loading: true,
        },
        replace: false,
      })
      this.callTreePreview({
        hSpotsParams,
        treeOperationsUpdate,
        fromStart,
      })
    },
    callTreePreview: throttle(function ({
      hSpotsParams,
      treeOperationsUpdate = false,
      fromStart = true,
    } = {}) {
      this.$store.dispatch(`${this.namespace}/slfrm_getTreePreview`, {
        hSpotsParams,
        treeOperationsUpdate,
        fromStart,
      })

      this.calculateReportPrice()
    }, 1111),
    calculateReportPrice() {
      if (!this.reportPriceHook) {
        this.reportPriceHook = useGetReportPrice()
      }

      const formResult = this.$store.getters[`${this.namespace}/slfrm_formApiPostData`]

      if (!formResult) {
        return
      }

      const customTree = {
        ...formResult,
        players: formResult.players.map(player => player),
        tree_operations: formResult.tree_operations || [],
        tree_incentives: formResult.tree_incentives || [],
        bet_sizes: formResult.bet_sizes || {
          bet_size: 'SMALL',
          value: {
            gto_value: 0,
            player_value: 0,
            sample_size: 0,
            gto_sample_size: 0,
            sufficient_sample_size: 0,
            gto_sufficient_sample_size: 0,
            sample_size_type: 'NO_SAMPLE',
            gto_sample_size_type: 'NO_SAMPLE',
          },
        },
        tournament_data: formResult.tournament_data || null,
      }

      const payload = {
        custom_tree: customTree,
      }

      this.reportPriceHook.mutate(
        { data: payload },
        {
          onSuccess: data => {
            this.lastReportPrice = Number(data?.price || 0)
          },
        },
      )
    },
    emptyHspots() {
      this.$store.commit(`${this.namespace}/gamestate_set`, {
        key: 'history_spots',
        value: [],
      })
    },
    handleEnter() {
      if (this.step !== 'summary') {
        this.step = this.stepOptions[this.stepOptions.indexOf(this.step) + 1]
        return
      }
      this.confirm()
    },
    async confirm() {
      if (!this.canConfirm) return
      if (this.shortcutsLoading) return
      if (this.presetLoading) return
      if (this.treesLoadingGET) return
      if (this.treesLoadingPOST) return
      this.$store.dispatch(`${this.namespace}/slfrm_createNewTree`, {
        solfigrNewTreeMode: this.l_solfigrNewTreeMode,
      })
    },
    openSaveTreeDialog() {
      if (!this.canConfirm) return

      const formResult = this.$store.getters[SNK(`slfrm_formApiPostData`, this.namespace)]
      const newSol = {
        ...formResult,
        name: '',
      }
      this.$store.commit(`${this.namespace}/slfrm_set`, {
        key: 'slfrm_selectedTree',
        value: newSol,
      })
      this.$store.dispatch(
        'router_set_dialogs',
        `solfigr-save-tree-dialog_namespace-${this.namespace}_mode-overwrite`,
      )
    },
    openNodeEditDialog() {
      const tmpNamespace = 'tmp/primary'
      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.namespace,
        to_namespace: tmpNamespace,
        queryGroup: 'nodedit',
      })
      this.nodeEditedSpot = this.$store.getters[`${this.namespace}/history_spot`]
      this.$store.dispatch(
        'router_set_dialogs',
        `solfigr-nodeedit-dialog_edit-tree_namespace-${this.namespace}_tmpNamespace-${tmpNamespace}`,
      )
    },
    openSavedTreesDialog() {
      this.$store.dispatch(
        'router_set_dialogs',
        `solfigr-saved-trees-dialog_namespace-${this.namespace}`,
      )
    },

    handleKeyPress(keys) {
      if (keys.includes('tab')) {
        const el = document.activeElement
        if (!el?.tagName !== 'INPUT') {
          setTimeout(() => {
            const inputs = document.querySelectorAll('input[type=text]')
            if (!inputs.length) return
            inputs[0].focus()
          })
        }
      }
    },
  },
  computed: {
    confirmDisabled() {
      return (
        this.$store.getters.user_has_flag('SOL_3WAY') &&
        this.solRepNamespace === namespaces.REPORTS &&
        this.players.length > 2
      )
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
    dialogMinWidth() {
      return this.$store.getters.user_has_flag('SOL_3WAY') ? '70rem' : '60.5rem'
    },
    createButtonText() {
      return this.solRepNamespace && this.solRepNamespace === namespaces.REPORTS
        ? this.$t('btn.create_custom_report')
        : this.$t('btn.create_custom_solution')
    },
    soltab() {
      return this.$store.getters.sw_tabs_study
    },
    solElite() {
      return this.$store.getters[SNK('sol_elite', this.solRepNamespace)]
    },
    solRepNamespace() {
      // #REFACTOR:NAMESPACES
      const pathName = getRouteNameByStudyTab(this.$router, this.$store.getters)
      return {
        StudySolutions: namespaces.STUDY,
        StudyReports: namespaces.REPORTS,
      }[pathName]
    },
    hSpotsLoading() {
      const loadingRanges = this.$store.getters.api_get(`api_poker_player_ranges`).loading
      const hSpotsEmpty = !this.$store.getters[`${this.namespace}/history_spots`].length
      const loadingTreePreview = this.$store.getters.api_get(`api_poker_tree_preview`).loading
      const skeleton = loadingRanges || hSpotsEmpty
      const res = {
        skeleton,
        spinner: !skeleton && loadingTreePreview,
      }

      return res
    },
    isPreflop() {
      return this.startStreet === 'preflop'
    },
    l_solfigrNewTreeMode() {
      return this.soltab === 'reports'
        ? 'createnew_reportsTab'
        : this.isPreflop
          ? 'createnew_preflop'
          : `${this.solfigrNewTreeMode}_flop`
    },
    tournamentType() {
      return this.$store.getters[`${this.namespace}/slfrm_tournamentType`]
    },
    icmTournament() {
      return this.$store.getters[`${this.namespace}/slfrm_icm_tournament`]
    },
    icmPlayersAndStacks() {
      return this.$store.getters[`${this.namespace}/slfrm_icm_playersAndStacks`]
    },
    icmHandDetails() {
      return this.$store.getters[`${this.namespace}/slfrm_icm_handDetails`]
    },
    board() {
      return this.$store.getters[`${this.namespace}/slfrm_board`]
    },
    shortcut() {
      return this.$store.getters[`${this.namespace}/slfrm_shortcut`]
    },
    gameformat() {
      return this.$store.getters[`${this.namespace ? `${this.namespace}/` : ''}gameformat`]
    },
    startStreet() {
      return this.$store.getters[`${this.namespace}/slfrm_startStreet`]
    },
    stack() {
      return this.isPreflop
        ? this.$store.getters[`${this.namespace}/slfrm_stack_preflop`]
        : this.$store.getters[`${this.namespace}/slfrm_stack_flop`]
    },
    stack_IP() {
      return !this.isPreflop
        ? this.$store.getters[SNK('slfrm_stack_flop_IP', this.namespace)]
        : undefined
    },
    stack_OOP() {
      return !this.isPreflop
        ? this.$store.getters[SNK('slfrm_stack_flop_OOP', this.namespace)]
        : undefined
    },
    stack_OOP1() {
      return !this.isPreflop
        ? this.$store.getters[SNK('slfrm_stack_flop_OOP1', this.namespace)]
        : undefined
    },
    pot() {
      return this.$store.getters[`${this.namespace}/slfrm_pot`]
    },
    ante() {
      return this.$store.getters[`${this.namespace}/slfrm_ante`]
    },
    anteDistributionMethod() {
      return this.$store.getters[`${this.namespace}/slfrm_ante_distribution_method`]
    },
    blind() {
      return this.$store.getters[`${this.namespace}/slfrm_blind`]
    },
    allowLimp() {
      return this.$store.getters[`${this.namespace}/slfrm_allow_limp`]
    },
    allowRake() {
      return this.isPreflop
        ? this.$store.getters[`${this.namespace}/slfrm_allowRake_preflop`]
        : this.$store.getters[`${this.namespace}/slfrm_allowRake_flop`]
    },
    rakePercent() {
      return this.isPreflop
        ? this.$store.getters[`${this.namespace}/slfrm_rakePercent_preflop`]
        : this.$store.getters[`${this.namespace}/slfrm_rakePercent_flop`]
    },
    rakeCap() {
      return this.isPreflop
        ? this.$store.getters[`${this.namespace}/slfrm_rakeCap_preflop`]
        : this.$store.getters[`${this.namespace}/slfrm_rakeCap_flop`]
    },
    preflopRakeType() {
      return this.$store.getters[`${this.namespace}/slfrm_preflopRakeType`]
    },
    selectedSolution() {
      return this.$store.getters[`${this.namespace}/slfrm_selectedTree`]
    },
    treeOperations() {
      return this.$store.getters[`${this.namespace}/slfrm_treeOperations`]
    },
    useFlopSizesOnAllStreets() {
      return this.$store.getters[`${this.namespace}/slfrm_useFlopSizesOnAllStreets`]
    },
    playersCloningFirstPlayer() {
      return this.$store.getters[SNK('slfrm_playersCloningFirstPlayer', this.namespace)]
    },
    allinTreshold() {
      return this.$store.getters[`${this.namespace}/slfrm_allin_threshold`]
    },
    allinIfLessThan() {
      return this.$store.getters[`${this.namespace}/slfrm_allin_if_less_than`]
    },
    mergeSizesThresholdPreflop() {
      return this.$store.getters[`${this.namespace}/slfrm_merge_sizes_threshold_preflop`]
    },
    mergeSizesThresholdFlop() {
      return this.$store.getters[`${this.namespace}/slfrm_merge_sizes_threshold_flop`]
    },
    maxNumRaises() {
      return this.$store.getters[`${this.namespace}/slfrm_max_num_raises`]
    },
    players() {
      return this.$store.getters[SNK('slfrm_players', this.namespace)]
    },
    stacks() {
      return this.$store.getters.user_has_flag('SOL_3WAY')
        ? { stack_IP: this.stack_IP, stack_OOP: this.stack_OOP, stack_OOP1: this.stack_OOP1 }
        : { stack_IP: this.stack_IP, stack_OOP: this.stack_OOP }
    },
    sizes() {
      return this.$store.getters[`${this.namespace}/slfrm_sizes`]
    },
    formResult() {
      return this.$store.getters[`${this.namespace}/slfrm_formApiPostData`]
    },
    modeAutoDynaIncluded() {
      const streetBetSizes = this.formResult.bet_sizes.street_bet_sizes
      const res = streetBetSizes.some(i =>
        i.position_bet_sizes.some(ii =>
          ['automatic', 'dynamic'].some(k => k === ii.type.toLowerCase()),
        ),
      )
      return res
    },
    apiCustomUserTrees() {
      return this.$store.getters.api_get('api_poker_custom_user_trees')
    },
    apiCustomSolutionTree() {
      const slfrmNamespace = ['StudySolutions', 'PracticeRangeBuilder'].includes(this.$route.name)
        ? ''
        : this.namespace
      return this.$store.getters.api_get('api_poker_custom_solution_tree', slfrmNamespace)
    },

    shortcutsLoading() {
      return this.$store.getters.api_get('api_poker_shortcuts', this.namespace).loading
    },
    presetLoading() {
      return this.$store.getters.api_get('api_poker_player_ranges').loading
    },
    treesLoadingGET() {
      return (
        (this.apiCustomSolutionTree.loading && this.apiCustomSolutionTree.method === 'get') || // initial load
        (this.apiCustomUserTrees.loading && this.apiCustomUserTrees.method === 'get') // load from saved trees
      )
    },
    treesLoadingPOST() {
      return this.apiCustomSolutionTree.loading && this.apiCustomSolutionTree.method === 'post'
    },
    canConfirm() {
      if (this.shortcutsLoading || this.presetLoading || this.treesLoadingGET) {
        return false
      }

      if (this.tournamentType === 'icm') {
        const tournamentOk = this.icmTournament && !this.icmTournament.errors.total_errors
        const handDetailsOk = this.icmHandDetails && !this.icmHandDetails.errors.total_errors
        return tournamentOk && handDetailsOk
      }

      if (this.isPreflop) {
        return this.conf.stack.preflop_stackAnteBlindCheck({
          stack: this.stack,
          ante: this.ante,
          preflop_SB: this.blind,
        })
      }

      return this.conf.stack.flop_stackPotCheck({
        stack: this.stack,
        pot: this.pot,
      })
    },
    hotkeyPressedBottom() {
      return this.$store.getters.hotkey_pressed_bottom
    },
    hotkeysPressed() {
      return this.$store.getters.hotkeys_pressed
    },
    globals_action() {
      return this.$store.getters.globals_action
    },
    shouldShowAddPlayerButton() {
      return (
        this.$store.getters.user_has_flag('SOL_3WAY') &&
        this.$store.getters[SNK('slfrm_shouldShowAddPlayerButton', this.namespace)]
      )
    },
    showComingSoonPlayerIcm() {
      return (
        this.$store.getters.user_has_flag('SOL_3WAY') &&
        this.$store.getters[SNK('slfrm_showComingSoonPlayerIcm', this.namespace)]
      )
    },
    creditsBalance() {
      return this.$store.getters.user_info.credit_balance
    },
  },
  watch: {
    hotkeyPressedBottom(key) {
      if (!key) return
      if (key === 'enter') {
        this.handleEnter()
      }
    },
    globals_action(action) {
      if (action === 'tree_operations_update') {
        this.$store.dispatch('globals_action_reset')

        const treeOperations = this.$store.getters[`${this.namespace}/slfrm_treeOperations`]
        if (!treeOperations.length) return
        this.handleUpdateTreeOperations()
      }
    },
    apiCustomUserTrees(apiCall) {
      if (apiCall.method === 'post') return // saving tree noes not concern us here

      const startingStreet = apiCall.response.data?.starting_street
      if (startingStreet) {
        this.$store.commit(`${this.namespace}/slfrm_set`, {
          key: 'slfrm_startStreet',
          value: startingStreet.toLowerCase(),
        })
      }
    },
    startStreet(street) {
      if (street === 'flop' && !this.players[0].groupRange.length) {
        this.fetchShortcut()
      }
    },
    formResult: {
      immediate: false,
      handler(newVal) {
        if (this.solRepNamespace === 'rep' && newVal) {
          this.calculateReportPrice()
        }
      },
    },
  },
}
</script>
<style lang="scss" scoped>
.solfigrtp {
  &_playerbox {
    min-height: 0;
    min-width: 18rem;
    flex: 1;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    overflow: hidden;
    background: var(--clr-black-1);
    border: solid 2px var(--clr-black-2);
    &_title {
      display: flex;
      align-items: center;
      background: var(--clr-black-2);
      height: 2.5rem;
      padding: 0 0.75rem;
    }
    &_position {
      font-weight: 500;
      color: var(--clr-white-0);
    }
    &_sizes {
      padding: 0.5rem 0.75rem 0.75rem 0.75rem;
    }
    &_disabled {
      .solfigrtp_playerbox_position {
        color: var(--clr-grey-2);
      }
    }
  }
}

.solfigr_steps {
  min-height: 0;
  min-width: 0;
  display: flex;
  position: relative;
  flex-direction: column;
  z-index: 4;
  &_content {
    display: flex;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    // overflow: hidden;
    width: clamp(1px, v-bind(dialogMinWidth), 100vw);
    height: var(--vh-6);
  }
  &_bottom {
    width: 100%;
    display: flex;
    min-height: 0;
    min-width: 0;
    flex-shrink: 0;
  }
}

@media (max-width: 1023px) {
  .solfigr_steps {
    &_content {
      height: var(--vh-3);
    }
  }
}

.chip {
  width: 16px;
}

.btn_create_custom_solution_text {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}
</style>
